import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/NavigationLink.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/components/ResponsiveImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/var/www/ouinex.com/frontend/src/components/ui/accordion.jsx");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/components/ui/separator.jsx");
